module.exports = __webpack_public_path__ + "img/ifa.e830bdd4.png";